import { EMPTY_USER_NAME } from "@shared/constants";

export const useGetUserName = (
  userName: string | undefined,
  isCurrentUser: boolean
): string => {
  if (userName) return userName;
  else if (isCurrentUser)
    return `${window.Telegram.WebApp.initDataUnsafe.user?.first_name} ${window.Telegram.WebApp.initDataUnsafe.user?.last_name}`;
  else return EMPTY_USER_NAME;
};
